
// ==============================================

//        PARALLAX EFX

// ==============================================

document.addEventListener('DOMContentLoaded', function(e) {


  //        Parallax on hero banners
  // ==============================================

  let parallaxEls   = document.querySelectorAll('.parallax');
  

  function doParallax() {
    let scrolled = window.pageYOffset;
    let windowH  = document.documentElement.clientHeight;

    parallaxEls.forEach( function( el ) {

        let elTop    = el.offsetParent.offsetTop + el.offsetTop;
        let elBottom = elTop + el.offsetHeight;
        let enterY   = (elTop - windowH >= 0) ? elTop - windowH : 0; // 0 if element top is outside of the window
        let leaveY   = elBottom;

        // element is visible on window -> set parallax transformation
        if (scrolled >= enterY && scrolled <= leaveY) {
          
          // parallax with background-position (data-rate-bg: [0, 50] )
          if (el.dataset.rateBg) {
            let yPos   = (50 - el.dataset.rateBg * scrolled/elBottom);
            // let coords = `50% 90%`;
            let coords = `50% ${yPos}%`;
            el.style.objectPosition = coords;
            // console.log('coords', yPos.toFixed(2), elBottom, scrolled);
              // console.log('\nelTop / elBottom', elTop, elBottom);
              // console.log('top / bottom', getCoords(el).height, getCoords(el).bottom);
              // console.log('enterY / leaveY', enterY, leaveY);
            
          // parallax with translate Y (data-speed-y: [-1, 1] )
          } else {
            let ty = el.dataset.speedY ? (scrolled - enterY) * -el.dataset.speedY : 0;
            let transform = `translate3d(0, ${ty}px, 0)`;
            el.style.transform = transform;
            // console.log('ty', el.dataset.speedy);
          }

        // element is outside of the window
        } else {
          // console.log(enterY, leaveY, scrolled,  "---");
        }
      
    });
  }
  window.addEventListener('scroll', doParallax);
  doParallax();


  // get document coordinates of the element relative to the document
  function getCoords(el) {
    var rect = el.getBoundingClientRect();

    return {
      top   : rect.top + window.pageYOffset,
      left  : rect.left + window.pageXOffset,
      bottom: rect.bottom + window.pageYOffset
    };
  }
})
